<status-banner role="status"></status-banner>
<main role="main">
  <router-outlet></router-outlet>
</main>
